export default {
  // 退出
  LogOut() {
    localStorage.clear();
  },
  // 取token
  GetToken() {
    return localStorage.getItem('token');
  },
  // 取用户基本信息
  GetStorage() {
    return JSON.parse(localStorage.getItem(localStorage.getItem('user')));
  },
  GetSession() {
    return JSON.parse(localStorage.getItem('session'));
  },
  // 用户的账号
  GetAccount() {
    return localStorage.getItem('account');
  },

  parseProtocal(data) {
    this.projectList = data;
    this.level1_data_list = data;
  },
};
